import { render, staticRenderFns } from "./ListPontaSlaView.vue?vue&type=template&id=55ec3356&"
import script from "./ListPontaSlaView.vue?vue&type=script&lang=ts&"
export * from "./ListPontaSlaView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports